/** Visor del IDE / iframe: popups y APIs de archivos suelen comportarse distinto que en Chrome externo. */

export function isEmbeddedBrowserContext() {
  if (typeof window === "undefined") return false;
  try {
    if (window.self !== window.top) return true;
  } catch {
    return true;
  }
  const ua = String(navigator.userAgent || "");
  return /Cursor|Electron|VSCode|WebView|iframe/i.test(ua);
}
